import React from "react";

import "./styles.css"; // Custom styles for the app
import { TopArtistCard } from "./component/topArtistCard";
import { ActionButton, ActionButtonFull } from "./component/buttons";
import { AirbudsYearlyHeader } from "./component/storyHeader";
import { useData } from "./data/dataContext";

import { useNavigate, Link } from "react-router";

export const TopArtist = ({}) => {
  const { data } = useData();
  const navigate = useNavigate();

  if (!data) {
    return <p>Loading...</p>;
  }

  if (!data.top_artists || data.top_artists.length <= 0) {
    return (
      <div ref={projectVisor} className="app-artist">
        <p>No artist</p>
      </div>
    );
  }

  const artist = data.top_artists[0];
  return (
    <div className="app-top-artist-container">
      <div className="app-artist-top app-artist-top-single">
        <div className="top-artist-card-container">
          <TopArtistCard data={artist} />

          <div className="buttons">
            <Link to="/artist-top-list">
              <ActionButton title="next" />
            </Link>
          </div>
        </div>
      </div>
      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
      />
    </div>
  );
};
